import { Messages, Common } from '@/config/NextImport'

export const getRingBuilderKey = () => {
  return Messages.Build_Your_Own_Stoage_Key
}
export const setDefaultRingBuilder = (
  path: string,
  isDiamond: number = 1,
  isGemstone: boolean = false
) => {
  const formatedPath = path?.includes('-sku-') ? path.split('/').slice(0, 3).join('/') : path
  const steps = [
    {
      stepno: 1,
      step: isDiamond ? 'diamond' : 'setting',
      IsCompleted: false,
      IsActive: true,
      url: formatedPath,
      IsGemstone: isGemstone
    },
    {
      stepno: 2,
      step: isDiamond ? 'setting' : 'diamond',
      IsCompleted: false,
      IsActive: false,
      url: '',
      IsGemstone: isGemstone
    },
    {
      stepno: 3,
      step: 'review',
      IsCompleted: false,
      IsActive: false,
      url: ''
    }
  ]
  localStorage[getRingBuilderKey()] = Common.encryptData(JSON.stringify(steps))
  // localStorage[getRingBuilderKey()] = JSON.stringify(steps)
}
export const setDiamondBuilder = (productUrl: string, isGemstone: boolean) => {
  const steps = [
    {
      stepno: 1,
      step: 'diamond',
      IsCompleted: false,
      IsActive: true,
      url: productUrl,
      recent_url: productUrl,
      IsGemstone: isGemstone
    },
    {
      stepno: 2,
      step: 'setting',
      IsCompleted: false,
      IsActive: false,
      url: '',
      recent_url: ''
    },
    {
      stepno: 3,
      step: 'review',
      IsActive: false,
      url: ''
    }
  ]

  localStorage[getRingBuilderKey()] = Common.encryptData(JSON.stringify(steps))
  // localStorage[GetRingBuilderKey()] = JSON.stringify(steps);
  sessionStorage[getRingBuilderKey()] = JSON.stringify(steps)
}
export const setSettingBuilder = (productUrl: string, isGemstone: boolean = false) => {
  const steps = [
    {
      stepno: 1,
      step: 'setting',
      IsCompleted: false,
      IsActive: true,
      url: productUrl,
      recent_url: productUrl,
      IsChange: false,
      IsView: false
    },
    {
      stepno: 2,
      step: 'diamond',
      IsCompleted: false,
      IsActive: false,
      url: '',
      recent_url: '',
      IsChange: false,
      IsView: false,
      IsGemstone: isGemstone
    },
    {
      stepno: 3,
      step: 'review',
      IsActive: false,
      url: ''
    }
  ]

  localStorage[getRingBuilderKey()] = Common.encryptData(JSON.stringify(steps))
  // localStorage[GetRingBuilderKey()] = JSON.stringify(steps);
  sessionStorage[getRingBuilderKey()] = JSON.stringify(steps)
}
export const getRingBuilder = () => {
  let getStorage = localStorage.getItem(getRingBuilderKey())
  if (getStorage != null) {
    getStorage = JSON.parse(Common.decryptData(getStorage))
    // getStorage = Common.GetJSON(getStorage)
  } else {
    getStorage = Common.GetJSON(sessionStorage.getItem(getRingBuilderKey())!)
  }
  return getStorage
}
export const setRingBuilder = (steps: any) => {
  localStorage[getRingBuilderKey()] = Common.encryptData(JSON.stringify(steps))
  // localStorage[getRingBuilderKey()] = JSON.stringify(steps)
  sessionStorage[getRingBuilderKey()] = JSON.stringify(steps)
}
export const setRingBuilderFromURL = (path: any, isDiamond = 1, isGemstone = false) => {
  const getStorage: any = getRingBuilder()
  // const parameters: any = new URLSearchParams(path.search)
  let isStorageSet = false
  const isDetailsPage = path?.includes('-sku-')
  const settingSku = isDetailsPage && isDiamond === 0 ? path.split('-sku-').reverse()[0] : undefined
  const diamondSku = isDetailsPage && isDiamond === 1 ? path.split('-sku-').reverse()[0] : undefined
  const isReviewStep = path?.includes('complete-jewel')

  if ((settingSku || diamondSku) && getStorage !== null) {
    // let paramSetting: any = parameters.get('setting')?.split('-sku-').reverse()[0]
    // if (sessionStorage.getItem(Messages.SettingType) === '3') paramSetting = parameters.get('sku')
    // const paramDiamond = parameters.get('diamond')?.split('-').reverse()[0]
    // const reviewDiamond =
    //   parameters.get('j')?.split('-').length > 0
    //     ? parameters.get('j')?.split('-').reverse()[0]
    //     : null
    // const reviewSetting =
    //   parameters.get('s')?.split('-').length > 0
    //     ? parameters.get('s')?.split('-sku-').reverse()[0]
    //     : null
    const isAnyStepPerfomed = getStorage.filter((x: any) => x.selected_productid !== undefined)
    getStorage.map((innerStep: any) => {
      if (
        // reviewDiamond == null &&
        // reviewSetting == null &&
        !isReviewStep &&
        isDiamond === 1 &&
        innerStep.step === 'diamond'
      ) {
        innerStep.IsActive = true
        // innerStep.selected_productid = diamondSku
        if (diamondSku !== undefined) innerStep.IsChange = false
        if (diamondSku === undefined && isAnyStepPerfomed.length === 0) {
          setDefaultRingBuilder(path, 1, isGemstone)
          isStorageSet = true
        }
        if (diamondSku !== undefined && isAnyStepPerfomed.length === 0) {
          // innerStep.selected_productid = diamondSku
          if (innerStep.stepno === 2) {
            const sStep = getStorage[0]
            getStorage[0] = innerStep
            getStorage[0].stepno = 1
            getStorage[1] = sStep
            getStorage[1].stepno = 2
          }
        }
      } else if (
        // reviewDiamond === null &&
        // reviewSetting === null &&
        !isReviewStep &&
        isDiamond === 0 &&
        innerStep.step === 'setting'
      ) {
        innerStep.IsActive = true
        // innerStep.selected_productid = settingSku
        if (settingSku !== undefined) innerStep.IsChange = false
        if (settingSku === undefined && isAnyStepPerfomed.length === 0) {
          setDefaultRingBuilder(path, 0, isGemstone)
          isStorageSet = true
        }
        if (settingSku !== undefined && isAnyStepPerfomed.length === 0) {
          // innerStep.selected_productid = settingSku
          if (innerStep.stepno === 2) {
            const dStep = getStorage[0]
            getStorage[0] = innerStep
            getStorage[0].stepno = 1
            getStorage[1] = dStep
            getStorage[1].stepno = 2
          }
        }
      } else if (
        // reviewDiamond != null && reviewSetting != null &&
        isReviewStep &&
        innerStep.step === 'review'
      ) {
        innerStep.IsActive = true
      } else {
        innerStep.IsActive = false
      }
      return true
    })
  } else if (getStorage != null) {
    const IsAnyStepPerfomed = getStorage.filter((x: any) => x.selected_productid !== undefined)
    if (IsAnyStepPerfomed.length === 0) {
      setDefaultRingBuilder(path, isDiamond, isGemstone)
      return
    } else {
      const stepName = isDiamond === 1 ? 'diamond' : 'setting'
      getStorage.map((innerStep: any) => {
        if (innerStep.step === stepName) {
          innerStep.IsActive = true
          innerStep.IsChange = true
          innerStep.IsView = false
        } else {
          innerStep.IsActive = false
          innerStep.IsChange = false
          innerStep.IsView = false
        }
        return true
      })
    }
  }
  if (!isStorageSet) setRingBuilder(getStorage)
}
export const removeRingBuilder = () => {
  localStorage.removeItem(getRingBuilderKey())
  sessionStorage.removeItem(getRingBuilderKey())
  removeRingBuilderConfig()
}
export const removeRingBuilderConfig = () => {
  localStorage.removeItem(getRingBuilderKey() + '_id')
  sessionStorage.removeItem(Messages.BuildYourOwnStoageKeyId)
}
export const editRingBuilder = (fromPage: any, id: any) => {
  localStorage[Messages.BuildYourOwnStoageKeyFrom] = fromPage
  localStorage[Messages.BuildYourOwnStoageKeyId] = id
}
